const IMSPolicy = () => {
  return (
    <div className="ims-policy-container">
      <header>
        <h1>INTEGRATED MANAGEMENT SYSTEM (IMS) POLICY</h1>
      </header>

      <main> 
        {/* Section 1 */}
        <section>
          <h2>1. Introduction</h2>

          <h3>1.1 Purpose</h3>
          <p>
            The purpose of this Integrated Management System (IMS) Policy is to
            establish the Checkoff commitment to implementing, maintaining and
            continually improving an integrated framework for Information
            Security Management, IT Service Management and Business Continuity
            Management in alignment with the ISO 27001, ISO 22301 and ISO 20000
            requirements.
          </p>

          <p>
            The policy provides the overarching principles and governance
            required to protect information assets, deliver reliable and
            high-quality services, ensure the continuity of critical business
            operations and effectively manage risks that may affect the
            achievement of the Checkoff Finance's strategic objectives.
          </p>

          <p>
            It also demonstrates the Company's commitment to complying with
            applicable legal, regulatory, contractual and other obligations
            while promoting a culture of continual improvement, operational
            excellence and organizational resilience.
          </p>

          <h3>1.2 Scope</h3>
          <p>
            This policy applies to the entire organization and covers all
            business units, departments, employees, contractors, consultants,
            temporary personnel and third-party service providers who perform
            activities on behalf of the Company or have access to its
            information, systems, facilities or services.
          </p>
        </section>

        {/* Section 2 */}
        <section>
          <h2>2. IMS Policy Statement</h2>

          <p>
            The Checkoff Finance policy for the implementation, operation,
            maintenance, and continual improvement of the Integrated Management
            System is as follows:
          </p>

          <h3>2.1 Management Commitment</h3>
          <p>
            Management is committed to maintaining an effective Integrated
            Management System that supports the organization's strategic
            direction, protects customer interests, strengthens operational
            resilience, and delivers continual value to all stakeholders.
          </p>

          <h3>2.2 Framework for Setting IMS Objectives</h3>
          <p>
            Checkoff Finance has established IMS objectives to support its
            strategic direction and to enhance the effectiveness of its
            Information Security Management System (ISMS), Business Continuity
            Management System (BCMS) and Service Management System (SMS).
          </p>

          <p>
            The IMS objectives are established in a manner that is consistent
            with the organization's strategic priorities, taking into
            consideration applicable legal, regulatory, contractual and other
            requirements, as well as identified risks and opportunities.
          </p>

          <p>
            The organization shall define, document, implement, maintain and
            periodically review the scope of the IMS.
          </p>

          <h3>2.3 Roles and Responsibilities</h3>

          <p>Senior Management provides leadership by:</p>

          <ul>
            <li>Establishing the strategic direction of the Integrated Management System.</li>
            <li>Approving IMS objectives and ensuring they remain aligned with business priorities.</li>
            <li>Providing adequate resources to support the IMS.</li>
            <li>Promoting continual improvement across the organization.</li>
          </ul>

          <p>Employees, contractors and other personnel are responsible for:</p>

          <ul>
            <li>Complying with this policy and supporting IMS objectives.</li>
            <li>Performing their assigned responsibilities in accordance with established procedures.</li>
            <li>Reporting risks, incidents, nonconformities and opportunities for improvement.</li>
          </ul>

          <h3>2.4 Continual Improvement</h3>

          <p>
            We are committed to the continual improvement of the IMS to enhance
            its effectiveness and performance.
          </p>

          <p>
            Continual improvement is achieved through the monitoring and
            measurement of processes, internal audits, management reviews,
            customer feedback, business continuity exercises, service
            performance evaluations, incident and nonconformity management,
            corrective actions and the ongoing assessment of risks and
            opportunities.
          </p>

          <p>
            Checkoff Finance uses the outcomes of these activities to strengthen
            its management systems, improve service delivery, enhance
            information security and increase organizational resilience.
          </p>
        </section>
      </main>
    </div>
  );
};

export default IMSPolicy;